import download from "downloadjs";
import { FILE_TYPES, MIME_TYPES, MAX_EXPORT_RECORDS } from "../constant/export";

export { MAX_EXPORT_RECORDS };

export const downloadBlob = (blob, filename, mimeType = MIME_TYPES.CSV) => {
  download(blob, filename, mimeType);
};

export const handleExportResponse = (response, onSuccess, onError) => {
  try {
    const { fileName, fileContent, fileType } = response.data;

    // Determine MIME type and create blob based on file type
    let blob;
    let mimeType;

    if (fileType === FILE_TYPES.XLSX) {
      const binaryString = window.atob(fileContent);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      blob = new Blob([bytes], { type: MIME_TYPES.XLSX });
      mimeType = MIME_TYPES.XLSX;
    } else {
      blob = new Blob([fileContent], { type: MIME_TYPES.CSV });
      mimeType = MIME_TYPES.CSV;
    }

    downloadBlob(blob, fileName, mimeType);

    if (onSuccess) {
      onSuccess(fileName);
    }
  } catch (error) {
    if (onError) {
      onError(error);
    }
  }
};
